import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { logo } from '@clofo/ui/images'

import { RequestEmailForm } from '../components/request-email-form'
import { RequestPasswordForm } from '../components/request-password-form'

/**
 * Adaptive login. Step one collects the email and probes for SSO: an SSO-enabled domain redirects
 * to the identity provider, otherwise we advance to the password step. Modeled on the legacy login
 * app's email-first flow.
 */
export const LoginPage = () => {
  // When returning from the forgot-password page (its Cancel action) the prior email is carried in
  // navigation state, so we resume directly on the password step instead of the email step.
  const { state } = useLocation()
  const [email, setEmail] = useState<string | null>(
    (state as { email?: string } | null)?.email || null,
  )

  return (
    <div className='flex flex-col bg-background items-center justify-center'>
      <img src={logo} alt='Closing Folders' className='my-13 h-15' />
      {email === null ? (
        <RequestEmailForm onPasswordRequired={setEmail} />
      ) : (
        <RequestPasswordForm email={email} onChangeEmail={() => setEmail(null)} />
      )}
    </div>
  )
}
